type ShouldUseMocksParams = {
    shouldUseInTest?: boolean;
    shouldUseInProxy?: boolean;
};

export const checkShouldUseMocks = ({ shouldUseInTest, shouldUseInProxy }: ShouldUseMocksParams = {}) => {
    const isEnvForMocks =
        process.env.NODE_ENV === 'development' || (shouldUseInTest && process.env.NODE_ENV === 'test');

    const isProxyForMocks =
        process.env.IS_PROXY_MODE !== 'true' || (shouldUseInProxy && process.env.IS_LOGGED_IN_PROXY !== 'true');

    return isEnvForMocks && isProxyForMocks;
};
